import { Link } from "gatsby"
import React from "react"
// import BookDemoButton from "./BookDemoButton"

const BookDemo = (props) => {

  const {title, text, cta} = props;

  return <section className="gs-sect__in gs-container">
          <header className="gs-sect-header tac">
            <h2 className="">{title || "Book a live demo"}</h2>
            <p className="mb2">
            {text || "See the OCUS® portable digital microscope scanner in action – request your free personal online live demo now. A Grundium expert will contact you personally to schedule a suitable 30-minute demo time for you. In the demo we will answer all your questions about which Ocus® scanner fits your needs best, we will talk pricing, share stories about how others are using the scanners, and help you fast forward the digital pathology experience in your lab."}
            </p>
            {/* <BookDemoButton/> */}
            <Link to="/book" className="gs-button gs-color-contrast">
              { cta || "Book your demo" }
            </Link>
          </header>
        </section>

}

export default BookDemo
